import validate from 'mixins/validate';

export default {
  data() {
    return {};
  },
  computed: {
    active() {
      return this.$parent.activeForm === 'login';
    },
  },
  mixins: [validate],
  mounted() {
    const formErrorsContainer = document.querySelector(
      '[data-form-errors-container]',
    );

    if (formErrorsContainer) {
      window.dataLayer.push({
        event: 'error_captured',
        error_message: 'login error, password or email are incorrect',
      });
    }
  },
  methods: {
    validateAndSubmitFormData(e) {
      const isValid = this.$children
        .filter((c) => {
          return typeof c.validateInput !== 'undefined';
        })
        .map((c) => {
          const valid = c.validateInput();
          if (typeof valid === 'object') return valid.valid;
          this.highlightErrors(c, valid);
          return valid;
        })
        .every((res) => res);
      if (!isValid) {
        e.preventDefault();
      } else {
        const form = this.$el.querySelector('.account-form--login');
        window.dataLayer?.push({
          event: 'login',
          method: 'email',
          eventCallback: () => {
            form.submit();
          },
          shopify_module_name: 'account login form'
        });
      }
    },
  },
};
